(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["LcCubeComps"] = factory(require("react"));
	else
		root["LcCubeComps"] = factory(root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__7__) {
return 